import React, { useMemo } from "react";
import { isNill } from "../../../../utils/common";
import style from "./index.module.scss";

interface Props {
  score: number;
  showScore?: boolean;
}

/**
 * 纯分数+星星
 * @param param0
 * @returns
 */
const ScoreStar = ({ score, showScore = true }: Props) => {
  // 重新处理分值
  const _score = useMemo(() => {
    if (isNill(score)) return '4.9'; // 无值或数据异常，默认 4.9
    else if (score < 3) return '3.0'; // 特殊考虑：低于 3.0 评分，按 3.0 显示
    else if (score > 5) return '5.0'; // 特殊考虑：任何高于 5.0 评分，按 5.0 显示，因为总分只有 5.0
    return (Math.floor(score * 10) / 10).toFixed(1); // 其他取小数点后一位
  }, [score]);

  // 根据分值渲染星星
  const restStar = useMemo(() => {
    let otherStar: any = [];
    const ___score = Number(_score);
    if (___score <= 3)
      otherStar.push(
        <span className={style.starNull} />,
        <span className={style.starNull} />
      );
    else if (___score < 4)
      otherStar.push(
        <span className={style.starHalf} />,
        <span className={style.starNull} />
      );
    else if (___score === 4)
      otherStar.push(
        <span className={style.starFull} />,
        <span className={style.starNull} />
      );
    else if (___score < 5)
      otherStar.push(
        <span className={style.starFull} />,
        <span className={style.starHalf} />
      );
    else
      otherStar.push(
        <span className={style.starFull} />,
        <span className={style.starFull} />
      );
    const baseStar = [
      <span className={style.starFull} />,
      <span className={style.starFull} />,
      <span className={style.starFull} />,
    ];
    return [...baseStar, ...otherStar];
  }, [_score]);

  return (
    <span className={style.scoreStarComp}>
      {showScore && <span className={style.scorePart}>{_score}</span>}
      <span className={style.starPart}>
        {restStar && restStar?.map((star) => star)}
      </span>
    </span>
  );
};

export default ScoreStar;
